import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { Router } from '@angular/router';
declare var CanvasJS: any;

@Component({
  selector: 'app-dynamic-report',
  templateUrl: './dynamic-report.component.html',
  styleUrls: ['./dynamic-report.component.css']
})
export class DynamicReportComponent implements OnInit {
  @ViewChild('excel_table') table: ElementRef;
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  model: any = {};
  dataresult: any = [];
  report_type: any;
  EMPS: any = [];
  getBilliedService: any = [];
  totInvocie: any;
  view: any[] = [600, 400];
  currentUser: any;
  years: number[] = [];
  constructor(
    private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router,
  ) { }


  onDateChanged(type, event: IMyDateModel): void {
  }


  ngOnInit() {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.model['new_exist'] = '';
    this.model['view_type'] = '';
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['period'] = 'Weekly';
    const currentYear = this.model['year'] = new Date().getFullYear();
    this.model['report_type'] = 'Employee';
    this.model['emp'] = '';
    this.model['week'] = '';
    this.model['month'] = '';
    this.model['semimonthly'] = '';
    this.model['quater'] = '';
    this.model['semiannually'] = '';
    this.model['service_desc'] = '';
    this.model['product_type'] = '1';
    for (let y = currentYear - 2; y <= currentYear + 1; y++) this.years.push(y);
    this.loginservice.getemp('', this.currentUser).subscribe(
      data => {
        if (data['comp_details'].length > 0) {
          this.EMPS = data['comp_details'];
        } else {
          this.EMPS = [];
          // this.dataresult = [];
        }
      }, error => { alert('Network Error getemp API'); });

    this.loginservice.getBilliedService('', this.currentUser).subscribe(
      data => {
        if (data['comp_details'].length > 0) {
          this.getBilliedService = data['comp_details'];
        } else {
          this.getBilliedService = [];
        }
      }, error => { alert('Network Error getBilliedService API'); });
  }

  getKeyValues(obj: any): { key: string, value: any[] }[] {
    return Object.keys(obj).map(key => ({ key, value: obj[key] }));
  }

  search() {
    if (this.model['new_exist'] == '1') {
      if (this.model['start_date'] == '' || this.model['end_date'] == '') {
        alert("Please Choose Start And End Date");
        this._flashMessagesService.show("Please Choose Start And End Date", { cssClass: 'alert-danger' });
        return true;
      }
    }

    this.loginservice.dynamicReport(this.model, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            if (data['comp_details1']) {
              this.dataresult = [];
              this.report_type = '';
              this.dataresult = data['comp_details1'];
              this.totInvocie = data['totInvocie'];
              this.report_type = data['report_type'];
            } else {
              this.dataresult = [];
              this.report_type = '';
              this.dataresult = data['comp_details'];
              this.totInvocie = data['totInvocie'];
              this.report_type = data['report_type'];
            }
            // if (data['comp_details2']) {
            //   let chart = new CanvasJS.Chart("chartContainer", {
            //     animationEnabled: true,
            //     theme: "light2", // "light1", "dark1", "dark2"
            //     title: {
            //       text: "Simple Column Chart"
            //     },
            //     axisY: {
            //       title: "Number of Units"
            //     },
            //     data: [{
            //       type: "column",
            //       dataPoints: data['comp_details2']
            //     }]
            //   });
            //   chart.render();
            // }


            // if (data['comp_details3']) {
            //   let chart = new CanvasJS.Chart("chartContainer1", {
            //     animationEnabled: true,
            //     theme: "light2", // "light1", "dark1", "dark2"
            //     title: {
            //       text: "Simple Column Chart1"
            //     },
            //     axisY: {
            //       title: "Number of Units1"
            //     },
            //     data: [{
            //       type: "column",
            //       dataPoints: data['comp_details3']
            //     }]
            //   });
            //   chart.render();
            // }
          }
          // else if (data['data'].length > 0) {
          //   if (data['data']) {
          //     this.dataresult = [];
          //     this.report_type = '';
          //     this.dataresult = data['data'];
          //     this.totInvocie = data['totInvocie'];
          //     this.report_type = data['report_type'];
          //   } else {
          //     this.dataresult = [];
          //     this.report_type = '';
          //     this.dataresult = data['data'];
          //     this.totInvocie = data['totInvocie'];
          //     this.report_type = data['report_type'];
          //   }
          // } 
          else if (data['status'] == 'not set') {
            this.dataresult = [];
            this.report_type = '';
            this.dataresult = [];
            this.totInvocie = 0;
            this.report_type = data['report_type'];
            this._flashMessagesService.show("Configure Collective Incentive Setup", { cssClass: 'alert-danger' });
          } else {
            this.dataresult = [];
            this.totInvocie = 0;
            this.report_type = '';
            this._flashMessagesService.show("No Records Found", { cssClass: 'alert-danger' });
          }

        }, error => { alert('Network Error dynamicReport API'); });
  }

  semiClear() {
    // this.model['new_exist'] = '';
    // this.model['start_date'] = '';
    // this.model['end_date'] = '';
    // this.model['period'] = 'Annually';
    // this.model['year'] = 2024;
    // this.model['report_type'] = 'Employee';
    this.dataresult = [];
    this.report_type = '';
  }

  reset() {
    this.ngOnInit();
  }

  printBill(bill_no, customer_id) {
    this.loginservice.printBill(bill_no, customer_id, this.currentUser)
      .subscribe(
        data => {
          if (data) {
            this.router.navigate(['print-preview'], {
              queryParams: {
                tot_amt: JSON.stringify(data['tot_amt']),
                invoiceTotal: JSON.stringify(data['invoiceTotal']),
                model: JSON.stringify(data['model']),
                multiple_offer: JSON.stringify(data['multiple_offer']),
                chekoutArray: JSON.stringify(data['chekoutArray']),
                product_multiple_offer: JSON.stringify(data['product_multiple_offer']),
                productsTobuy: JSON.stringify(data['productsTobuy']),
                discount: JSON.stringify(data['discount']),
                bill_no: JSON.stringify(data['bill_no']),
              }
            });
          }
        }, error => { alert('Network Error printBill API'); });
  }

  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);//converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Invoice Report.xlsx');
  }

  public mprint() {
    window.print();
  }

  Objecttodate(obj) {
    if (typeof obj === 'object') {
      return obj.day + '-' + obj.month + '-' + obj.year;
    } else {
      return '';
    }
  }

  toNum(add_charge_value) {
    return Number(add_charge_value)
  }

  resetData() {
    this.dataresult = [];
    this.totInvocie = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/dynamic-report/dynamic-report.component.ts